import React, { FC, useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
import { useMapSlice } from '../../slice';
import { selectFitCoordArrOnMap } from '../../slice/selectors';
import * as L from 'leaflet';

interface IProps {}

const ZoomControl: FC<IProps> = ({ children }) => {
  const dispatch = useDispatch();

  const { actions } = useMapSlice();

  const fitCoordArrOnMap = useSelector(selectFitCoordArrOnMap);

  const map = useMap();

  useEffect(() => {
    if (map && fitCoordArrOnMap) {
      dispatch(actions.setFitCoordArrOnMap(null));

      if (fitCoordArrOnMap.length) {
        const bounds = L.latLngBounds(fitCoordArrOnMap);
        map.fitBounds(bounds);
      }
    }
  }, [map, fitCoordArrOnMap, actions, dispatch]);

  return <>{children}</>;
};

export default ZoomControl;
